import { render } from "./WorkContact.vue?vue&type=template&id=122f934f&scoped=true"
import script from "./WorkContact.vue?vue&type=script&lang=js"
export * from "./WorkContact.vue?vue&type=script&lang=js"

import "./WorkContact.vue?vue&type=style&index=0&id=122f934f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122f934f"]])

export default __exports__